<script lang="ts" setup>
// Properties
import { onMounted } from "vue";
import H2Heading from "~/components/H2Heading.vue";

const props = defineProps({
    product: {
        type: Object,
    },
});

// Data
const slides = [
    {
        title: "Recycling",
        detail:
            "While manufacturing our print workbooks, thousands of tiny pieces of paper waste are created during " +
            "the trimming process. Due to our recycling efforts, approximately " +
            "<b>140,000 lbs of paper is saved from landfills annually.</b>",
        image: "/images/about/about-us_carousel-environment-1_396x344px.jpg",
    },
    {
        title: "Energy Conservation",
        detail:
            "ABC has invested in preserving energy resources with new 143w/19,500 lumen LED lighting. With " +
            "this new lighting in our manufacturing facility, we use 65% less energy on lighting and also " +
            "substantially reduce air conditioning usage due to these lower-temperature lights.",
        image: "/images/about/about-us_carousel-environment-2_396x344px.jpg",
    },
];

// Functions

onMounted(async () => {
    // swiper element
    const swiperEl = document.querySelector("#env-cares-slides");
    const btnNext = document.querySelector("#env-cares-slides-btn-next");
    const btnPrev = document.querySelector("#env-cares-slides-btn-prev");

    // swiper parameters
    const swiperParams = {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        navigation: {
            nextEl: btnNext,
            prevEl: btnPrev,
        },
        autoplay: {
            delay: 8000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },
        on: {
            init() {
                // ...
            },
        },
    };

    // now we need to assign all parameters to Swiper element
    Object.assign(swiperEl, swiperParams);

    // and now initialize it
    swiperEl?.initialize();
});
</script>

<template>
    <div class="bg-abc-gray py-14">
        <H2Heading size="text-2xl md:text-3xl" class="mb-2 text-center">Environment</H2Heading>
        <p class="mb-10 text-center md:px-20 lg:px-60">
            ABC cares about the impact of our manufacturing processes and we take efforts to reduce energy consumption
            and waste.
        </p>

        <!-- Slides -->
        <div class="relative">
            <swiper-container
                id="env-cares-slides"
                init="false"
                class="swiper-container swiper-initialized swiper-horizontal px-2 md:w-[70%] lg:w-[80%] xl:w-[87%]"
            >
                <swiper-slide v-for="(slide, index) in slides" :key="index" class="overflow-hidden">
                    <div
                        class="items-center overflow-hidden rounded-xl border bg-white pb-6 drop-shadow-sm lg:mx-4 lg:flex lg:py-0 xl:mx-8"
                    >
                        <div class="relative w-full flex-1 overflow-hidden lg:w-2/5">
                            <img
                                :src="slide.image"
                                :alt="slide.title"
                                class="mx-auto hidden h-64 md:block lg:inline-block xl:h-72"
                            />
                            <img
                                src="/images/about/About-us-carousel-bubbles_68x342px.svg"
                                class="hidden h-72 xl:inline-block"
                            />
                            <img
                                src="/images/about/About-us-carousel-bubbles_mobile_306x54px.svg"
                                class="top-0 right-0 -z-10 float-right -mt-4 max-h-32 md:absolute lg:hidden"
                            />
                        </div>
                        <div class="mt-2 flex-1 pr-4 pl-4 text-center lg:mt-0 lg:pr-8 lg:text-left xl:pr-16">
                            <div class="font-semibold">{{ slide.title }}</div>
                            <p class="mt-3 leading-tight" v-html="slide.detail"></p>
                        </div>
                    </div>
                </swiper-slide>
            </swiper-container>

            <div class="absolute top-0 right-0 z-10 hidden h-full items-center justify-center border-l-0 p-4 md:flex">
                <div
                    id="env-cares-slides-btn-next"
                    class="flex-none cursor-pointer rounded-full border bg-white px-5 py-3 shadow-lg hover:border-2"
                >
                    <img src="/images/fa/chevron-right-regular.svg" class="w-5" />
                </div>
            </div>
            <div class="absolute top-0 left-0 z-10 hidden h-full items-center justify-center border-r-0 p-4 md:flex">
                <div
                    id="env-cares-slides-btn-prev"
                    class="flex-none cursor-pointer rounded-full border bg-white px-5 py-3 shadow-lg hover:border-2"
                >
                    <img src="/images/fa/chevron-left-regular.svg" class="w-5" />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
